import React, { useState, useEffect } from 'react';

const NewsForm = ({ initialData, categories, onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    title: '',
    title_ky: '',
    summary: '',
    summary_ky: '',
    content: '',
    content_ky: '',
    category: '',
    cover_image: null,
    status: 'published',
    is_featured: false,
    is_breaking: false,
    allow_comments: true
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        title_ky: initialData.title_ky || '',
        summary: initialData.summary || '',
        summary_ky: initialData.summary_ky || '',
        content: initialData.content || '',
        content_ky: initialData.content_ky || '',
        category: initialData.category?.id || '',
        cover_image: null, // Изображения обычно не подгружаются обратно в input type="file"
        status: initialData.status || 'published',
        is_featured: initialData.is_featured || false,
        is_breaking: initialData.is_breaking || false,
        allow_comments: initialData.allow_comments !== undefined ? initialData.allow_comments : true,
        media_files: []
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else if (type === 'file') {
      if (name === 'media_files') {
        setFormData(prev => ({ ...prev, [name]: Array.from(files) }));
      } else {
        setFormData(prev => ({ ...prev, [name]: files[0] }));
      }
    } else {
      setFormData(prev => ({ 
        ...prev, 
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="form-row">
        <div className="form-group full-width">
          <label>Заголовок *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            placeholder="Русский"
          />
           <input
            type="text"
            name="title_ky"
            value={formData.title_ky}
            onChange={handleChange}
            placeholder="Кыргызча"
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group full-width">
          <label>Краткое описание *</label>
          <textarea
            name="summary"
            value={formData.summary}
            onChange={handleChange}
            rows="3"
            required
             placeholder="Русский"
          />
           <textarea
            name="summary_ky"
            value={formData.summary_ky}
            onChange={handleChange}
            rows="3"
             placeholder="Кыргызча"
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group full-width">
          <label>Содержание *</label>
          <textarea
            name="content"
            value={formData.content}
            onChange={handleChange}
            rows="10"
            required
             placeholder="Русский"
          />
           <textarea
            name="content_ky"
            value={formData.content_ky}
            onChange={handleChange}
            rows="10"
            placeholder="Кыргызча"
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Категория</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            <option value="">Без категории</option>
            {Array.isArray(categories) && categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Статус</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="draft">Черновик</option>
            <option value="published">Опубликовано</option>
            <option value="archived">В архиве</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Обложка</label>
          <input
            type="file"
            name="cover_image"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Медиа-файлы (Фото/Видео)</label>
          <input
            type="file"
            name="media_files"
            accept="image/*,video/*"
            multiple
            onChange={handleChange}
          />
          <small>Можно выбрать несколько файлов. Поддерживаются изображения и видео.</small>
          {initialData && initialData.media_files && initialData.media_files.length > 0 && (
             <div style={{ marginTop: '10px' }}>
               <small>Текущие файлы (будут заменены при загрузке новых):</small>
               <ul style={{ paddingLeft: '20px', fontSize: '12px' }}>
                 {initialData.media_files.map(file => (
                   <li key={file.id}>
                     {file.media_type === 'image' ? '🖼️' : '🎥'} {file.file.split('/').pop()}
                   </li>
                 ))}
               </ul>
             </div>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_featured"
              checked={formData.is_featured}
              onChange={handleChange}
            />
            Важная новость
          </label>
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_breaking"
              checked={formData.is_breaking}
              onChange={handleChange}
            />
            Срочная новость
          </label>
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="allow_comments"
              checked={formData.allow_comments}
              onChange={handleChange}
            />
            Разрешить комментарии
          </label>
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Сохранение...' : (initialData ? 'Обновить новость' : 'Опубликовать новость')}
        </button>
        <button type="button" className="cancel-button" onClick={onCancel}>
          Отмена
        </button>
      </div>
    </form>
  );
};

export default NewsForm;
